import { ReactElement } from 'react'
import { BookingPaymentsMethod } from './Payments'

import { BookingPaymentsSummary } from './Summary'
import { BookingPaymentsByTickets } from './Tickets'

export const BookingPaymentsList = ({
  booking,
  newTickets = [],
  returnTrips,
  editPriceDisabled,
  tripChangeProposalId,
  ...props
}: TSFixMe): ReactElement => {
  return (
    <>
      <BookingPaymentsByTickets
        booking={booking}
        newTickets={newTickets}
        editPriceDisabled={editPriceDisabled}
        returnTrips={returnTrips}
      />
      <BookingPaymentsMethod booking={booking} editPriceDisabled={editPriceDisabled} {...props} />
      <BookingPaymentsSummary
        booking={booking}
        newTickets={newTickets}
        editPriceDisabled={editPriceDisabled}
        tripChangeProposalId={tripChangeProposalId}
      />
    </>
  )
}
